export default __webpack_public_path__ + "static/media/2229.d23acaa8.png";